import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import AssetPurchaseOrderDetails from '@/types/table/assetPurchaseOrderDetails';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface AssetPurchaseOrderDetailsData extends AssetPurchaseOrderDetails {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class AssetPurchaseOrderDetailsController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<AssetPurchaseOrderDetailsData>>(
      API_CONTEXT + '/asset/assetPurchaseOrderDetails/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<AssetPurchaseOrderDetailsData>(
      API_CONTEXT + '/asset/assetPurchaseOrderDetails/view',
      params,
      httpOptions,
    );
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(
      API_CONTEXT + '/asset/assetPurchaseOrderDetails/export',
      params,
      fileName,
    );
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/asset/assetPurchaseOrderDetails/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/asset/assetPurchaseOrderDetails/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetPurchaseOrderDetails/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetPurchaseOrderDetails/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/asset/assetPurchaseOrderDetails/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/asset/assetPurchaseOrderDetails/deleteBatch',
      params,
      httpOptions,
    );
  }
}
